import moment from 'moment'

export interface DateRange {
  startDate: string
  endDate?: string
}

interface Props {
  assignedDates: DateRange[]
  selectedDateRange: DateRange
}

const isIncomplete = (range: DateRange) => {
  return !range.startDate
}

const markedAsOngoing = (date: string | undefined | null) => {
  return date === '' || date === null || date === undefined
}

const assignmentBetween = (
  startDate: moment.Moment,
  endDate: moment.Moment,
  assignmentStart: moment.Moment,
  assignmentEnd: moment.Moment | null
) => {
  return (
    startDate.isSameOrBefore(assignmentEnd, 'day') && endDate.isSameOrAfter(assignmentStart, 'day')
  )
}

const sameOrBeforeAssignment = (date: moment.Moment, assignmentDate: moment.Moment) => {
  return date.isSameOrBefore(assignmentDate, 'day')
}

export const assignmentOverlaps = ({ assignedDates, selectedDateRange }: Props) => {
  const startDate = moment(selectedDateRange.startDate)

  if (isIncomplete(selectedDateRange)) return false

  return assignedDates?.some((assignment) => {
    const assignmentStart = moment(assignment.startDate)
    const assignmentEnd = assignment.endDate ? moment(assignment.endDate) : null

    if (markedAsOngoing(selectedDateRange.endDate)) {
      if (assignmentEnd) {
        return (
          sameOrBeforeAssignment(startDate, assignmentStart) ||
          sameOrBeforeAssignment(startDate, assignmentEnd)
        )
      }

      return sameOrBeforeAssignment(startDate, assignmentStart)
    }

    const endDate = moment(selectedDateRange.endDate)

    if (markedAsOngoing(assignment.endDate)) {
      if (endDate) {
        return assignmentStart.isBetween(startDate, endDate, undefined, '[]')
      }

      return sameOrBeforeAssignment(startDate, assignmentStart)
    }

    return assignmentBetween(startDate, endDate, assignmentStart, assignmentEnd)
  })
}
